<ng-template #content let-modal>
	<div class="modal-guide">
		<div class="modal-header">
			<h3 class="modal-title guide-title">Visualización de guía de envío</h3>
			<button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
				<span aria-hidden="true">&times;</span>
			</button>
		</div>
		<div class="modal-body">
			<p>Aquí va la información de la guía del pedido.</p>
		</div>
		<div class="modal-footer">
			<button type="button" class="btn btn-secondary" (click)="modal.close('Close click')">
				<fa-icon [icon]="faDownload" class="icon"></fa-icon>
				Descargar guía
			</button>
		</div>
	</div>
</ng-template>